import { render, staticRenderFns } from "./CommunityGuidelinesCopy.vue?vue&type=template&id=2ae8bf5c&scoped=true&"
import script from "./CommunityGuidelinesCopy.vue?vue&type=script&lang=js&"
export * from "./CommunityGuidelinesCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae8bf5c",
  null
  
)

export default component.exports